/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import Checkbox from '@material-ui/core/Checkbox';
import { TextareaAutosize } from '@material-ui/core';
import { setGenSysParamDataRedux } from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

function GeneralSystemParameters(props) {
  const {
    setUpdateGenSysparameter,
    setSystemParameterData,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    isReadOnly,
    isEnabledByRole,
  } = props;
  const { setSuccessMessage } = props;
  const dispatch = useDispatch();
  const payload = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );
  const genSysParamData = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.genSysParamData
  );

  const [openConfirmationPopup, setOpenConfirmationPopup] = useState(false);
  const [allowNewClientGroupPlan, setAllowNewClientGroupPlan] = useState(false);
  const [preventCorrCommUpdate, setPreventCorrCommUpdate] = useState(false);
  const [checkLogByCashControlNum, setCheckLogByCashControlNum] =
    useState(false);
  const [strongPasswordRequired, setStrongPasswordRequired] = useState(false);
  const [checkLogUsesBatchNum, setCheckLogUsesBatchNum] = useState(false);
  const [drugGrossAmount, setDrugGrossAmount] = useState(false);
  const [hideCMSURAUROA, setHideCMSURAUROA] = useState(false);
  const [showAlternateTheraClass, setShowAlternateTheraClass] = useState(false);
  const [fTPCMSUtilizationTape, setFTPCMSUtilizationTape] = useState(false);
  const [messageText, setMessageText] = useState(false);
  const [iPAddress, setIPAddress] = useState();
  const [userID, setUserID] = useState();
  const [passwordtxt, setPasswordTxt] = useState();
  const [textMessage, setTextMessage] = useState();
  const [dataSet, setDataSet] = useState({
    allowNewCgpInd: null,
    preventCcUpdateInd: null,
    checkLogByCcnInd: null,
    strongPwReqInd: null,
    checkLogUsesBatchInd: null,
    drugGrossAmtInd: null,
    hideCmsUraInd: null,
    showSpecialTheraClassInd: null,
    ftpCmsTapeInd: null,
    secLoginInd: null,
    ftpIpAddress: null,
    ftpUserId: null,
    ftpPassword: null,
    secLoginMsg: null,
    aboutMessageText: null,
    extFileDir: null,
  });
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const updateGenSysparameter = {
    allowNewCgpInd: null,
    preventCcUpdateInd: null,
    checkLogByCcnInd: null,
    strongPwReqInd: null,
    checkLogUsesBatchInd: null,
    drugGrossAmtInd: null,
    hideCmsUraInd: null,
    showSpecialTheraClassInd: null,
    ftpCmsTapeInd: null,
    secLoginInd: null,
    ftpIpAddress: null,
    ftpUserId: null,
    ftpPassword: null,
    secLoginMsg: null,
    aboutMessageText: null,
    extFileDir: null,
  };

  useEffect(() => {
    if (genSysParamData && !disabledSaveCancelBtn) {
      setAllowNewClientGroupPlan(genSysParamData.allowNewCgpInd);
      setPreventCorrCommUpdate(genSysParamData.preventCcUpdateInd);
      setCheckLogByCashControlNum(genSysParamData.checkLogByCcnInd);
      setStrongPasswordRequired(genSysParamData.strongPwReqInd);
      setCheckLogUsesBatchNum(genSysParamData.checkLogUsesBatchInd);
      setDrugGrossAmount(genSysParamData.drugGrossAmtInd);
      setHideCMSURAUROA(genSysParamData.hideCmsUraInd);
      setShowAlternateTheraClass(genSysParamData.showSpecialTheraClassInd);
      setFTPCMSUtilizationTape(genSysParamData.ftpCmsTapeInd);
      setMessageText(genSysParamData.secLoginInd);
      setIPAddress(genSysParamData.ftpIpAddress);
      setUserID(genSysParamData.ftpUserId);
      setPasswordTxt(genSysParamData.ftpPassword);
      setTextMessage(genSysParamData.secLoginMsg);
      setDataSet(genSysParamData);
    } else if (payload && payload.length > 0) {
      if (payload[0].allowNewCgpInd) {
        updateGenSysparameter.allowNewCgpInd = 1;
        setAllowNewClientGroupPlan(true);
      } else {
        updateGenSysparameter.allowNewCgpInd = 0;
        setAllowNewClientGroupPlan(false);
      }
      if (payload[0].preventCcUpdateInd) {
        updateGenSysparameter.preventCcUpdateInd = 1;
        setPreventCorrCommUpdate(true);
      } else {
        updateGenSysparameter.preventCcUpdateInd = 0;
        setPreventCorrCommUpdate(false);
      }
      if (payload[0].checkLogByCcnInd) {
        updateGenSysparameter.checkLogByCcnInd = 1;
        setCheckLogByCashControlNum(true);
      } else {
        updateGenSysparameter.checkLogByCcnInd = 0;
        setCheckLogByCashControlNum(false);
      }
      if (payload[0].strongPwReqInd) {
        updateGenSysparameter.strongPwReqInd = 1;
        setStrongPasswordRequired(true);
      } else {
        updateGenSysparameter.strongPwReqInd = 0;
        setStrongPasswordRequired(false);
      }
      if (payload[0].checkLogUsesBatchInd) {
        updateGenSysparameter.checkLogUsesBatchInd = 1;
        setCheckLogUsesBatchNum(true);
      } else {
        updateGenSysparameter.checkLogUsesBatchInd = 0;
        setCheckLogUsesBatchNum(false);
      }
      if (payload[0].drugGrossAmtInd) {
        updateGenSysparameter.drugGrossAmtInd = 1;
        setDrugGrossAmount(true);
      } else {
        updateGenSysparameter.drugGrossAmtInd = 0;
        setDrugGrossAmount(false);
      }
      if (payload[0].hideCmsUraInd) {
        updateGenSysparameter.hideCmsUraInd = 1;
        setHideCMSURAUROA(true);
      } else {
        updateGenSysparameter.hideCmsUraInd = 0;
        setHideCMSURAUROA(false);
      }
      if (payload[0].showSpecialTheraClassInd) {
        updateGenSysparameter.showSpecialTheraClassInd = 1;
        setShowAlternateTheraClass(true);
      } else {
        updateGenSysparameter.showSpecialTheraClassInd = 0;
        setShowAlternateTheraClass(false);
      }
      if (payload[0].ftpCmsTapeInd) {
        updateGenSysparameter.ftpCmsTapeInd = 1;
        setFTPCMSUtilizationTape(true);
      } else {
        updateGenSysparameter.ftpCmsTapeInd = 0;
        setFTPCMSUtilizationTape(false);
      }
      if (payload[0].secLoginInd) {
        updateGenSysparameter.secLoginInd = 1;
        setMessageText(true);
      } else {
        updateGenSysparameter.secLoginInd = 0;
        setMessageText(false);
      }
      updateGenSysparameter.ftpIpAddress = payload[0].ftpIpAddress;
      updateGenSysparameter.ftpPassword = payload[0].ftpPassword;
      updateGenSysparameter.ftpUserId = payload[0].ftpUserId;
      updateGenSysparameter.secLoginMsg = payload[0].secLoginMsg;
      updateGenSysparameter.extFileDir = payload[0].extFileDir;
      updateGenSysparameter.aboutMessageText = payload[0].aboutMessageText;
      setIPAddress(payload[0].ftpIpAddress);
      setUserID(payload[0].ftpUserId);
      setPasswordTxt(payload[0].ftpPassword);
      setTextMessage(payload[0].secLoginMsg);
      setDataSet(updateGenSysparameter);
      /*    const systemParamData = [];
        systemParamData(payload[0]); */
      setSystemParameterData(payload[0]);
    }
    return ()=>{
      setSuccessMessage([])
    }
  }, [payload]);

  const handleChange = (event, field) => {
    setDisabledSaveCancelBtn(false);
  setSuccessMessage([]);
    if (dataSet) {
      if (field === 'allowNewClientGroupPlan') {
        dataSet.allowNewCgpInd = event.target.checked ? 1 : 0;
        setAllowNewClientGroupPlan(event.target.checked);
      }
      if (field === 'preventCorrCommUpdate') {
        dataSet.preventCcUpdateInd = event.target.checked ? 1 : 0;
        setPreventCorrCommUpdate(event.target.checked);
      }
      if (field === 'checkLogByCashControlNum') {
        dataSet.checkLogByCcnInd = event.target.checked ? 1 : 0;
        setCheckLogByCashControlNum(event.target.checked);
      }
      if (field === 'checkLogUsesBatchNum') {
        dataSet.checkLogUsesBatchInd = event.target.checked ? 1 : 0;
        setCheckLogUsesBatchNum(event.target.checked);
      }
      if (field === 'drugGrossAmount') {
        dataSet.drugGrossAmtInd = event.target.checked ? 1 : 0;
        setDrugGrossAmount(event.target.checked);
      }
      if (field === 'hideCMSURAUROA') {
        dataSet.hideCmsUraInd = event.target.checked ? 1 : 0;
        setHideCMSURAUROA(event.target.checked);
      }
      if (field === 'showAlternateTheraClass') {
        dataSet.showSpecialTheraClassInd = event.target.checked ? 1 : 0;
        setShowAlternateTheraClass(event.target.checked);
      }
      if (field === 'fTPCMSUtilizationTape') {
        dataSet.ftpCmsTapeInd = event.target.checked ? 1 : 0;
        setFTPCMSUtilizationTape(event.target.checked);
      }
      if (field === 'messageText') {
        dataSet.secLoginInd = event.target.checked ? 1 : 0;
        setMessageText(event.target.checked);
      }
      if (field === 'iPAddress') {
        dataSet.ftpIpAddress = event.target.value;
        setIPAddress(event.target.value);
      }
      if (field === 'userID') {
        dataSet.ftpUserId = event.target.value;
        setUserID(event.target.value);
      }
      if (field === 'passwordtxt') {
        dataSet.ftpPassword = event.target.value;
        setPasswordTxt(event.target.value);
      }
      if (field === 'textMessage') {
        dataSet.secLoginMsg = event.target.value;
        setTextMessage(event.target.value);
      }
    }
    if (field === 'preventCorrCommUpdate') {
      dataSet.preventCcUpdateInd = event.target.checked ? 1 : 0;
      setPreventCorrCommUpdate(event.target.checked);
    }
    if (field === 'checkLogByCashControlNum') {
      dataSet.checkLogByCcnInd = event.target.checked ? 1 : 0;
      setCheckLogByCashControlNum(event.target.checked);
    }
    if (field === 'checkLogUsesBatchNum') {
      dataSet.checkLogUsesBatchInd = event.target.checked ? 1 : 0;
      setCheckLogUsesBatchNum(event.target.checked);
    }
    if (field === 'drugGrossAmount') {
      dataSet.drugGrossAmtInd = event.target.checked ? 1 : 0;
      setDrugGrossAmount(event.target.checked);
    }
    if (field === 'hideCMSURAUROA') {
      dataSet.hideCmsUraInd = event.target.checked ? 1 : 0;
      setHideCMSURAUROA(event.target.checked);
    }
    if (field === 'showAlternateTheraClass') {
      dataSet.showSpecialTheraClassInd = event.target.checked ? 1 : 0;
      setShowAlternateTheraClass(event.target.checked);
    }
    if (field === 'fTPCMSUtilizationTape') {
      dataSet.ftpCmsTapeInd = event.target.checked ? 1 : 0;
      setFTPCMSUtilizationTape(event.target.checked);
    }
    if (field === 'messageText') {
      dataSet.secLoginInd = event.target.checked ? 1 : 0;
      setMessageText(event.target.checked);
    }
    if (field === 'iPAddress') {
      dataSet.ftpIpAddress = event.target.value;
      setIPAddress(event.target.value);
    }
    if (field === 'userID') {
      dataSet.ftpUserId = event.target.value;
      setUserID(event.target.value);
    }
    if (field === 'passwordtxt') {
      dataSet.ftpPassword = event.target.value;
      setPasswordTxt(event.target.value);
    }
    if (field === 'textMessage') {
      dataSet.secLoginMsg = event.target.value;
      setTextMessage(event.target.value);
    }
    setUpdateGenSysparameter(dataSet);
    dispatch(setGenSysParamDataRedux(dataSet));
  };

  const handleViewHistory = () => {
    setSuccessMessage([]);
    setShowViewHistory(true);
    setKeyValue({
      LAST_UPDATE_DT: payload[0].lastUpdateDt,
    });
  };

  return (
    <>
      <div>
        <SaveCancelPopup
          open={openConfirmationPopup}
          title='Enable Strong Password'
          onConfim={() => {
            setStrongPasswordRequired(true);
            setOpenConfirmationPopup(false);
          }}
          onCancel={() => {
            setStrongPasswordRequired(false);
            setOpenConfirmationPopup(false);
          }}
        />
        <fieldset className='custom-fieldset'>
          <legend className='same-font-family'>Options</legend>
          <div className='off'>
            <div className='row mb-3 ml-3'>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'allowNewClientGroupPlan');
                            }}
                            checked={allowNewClientGroupPlan}
                          />
                        }
                        label='Allow New Client Group Plan'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'checkLogByCashControlNum');
                            }}
                            checked={checkLogByCashControlNum}
                          />
                        }
                        label='Check Log By Cash Control Num'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'checkLogUsesBatchNum');
                            }}
                            checked={checkLogUsesBatchNum}
                          />
                        }
                        label='Check Log Uses Batch Num'
                        labelPlacement='end'
                        value
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-3 ml-3'>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'hideCMSURAUROA');
                            }}
                            checked={hideCMSURAUROA}
                          />
                        }
                        label='Hide CMS URA/UROA'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'fTPCMSUtilizationTape');
                            }}
                            checked={fTPCMSUtilizationTape}
                          />
                        }
                        label='FTP CMS Utilization Tape'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'preventCorrCommUpdate');
                            }}
                            checked={preventCorrCommUpdate}
                          />
                        }
                        label='Prevent Corr/Comm Update'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='row mb-2 ml-3'>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            /* onChange={(e) => {
                              handleChange(e, "strongPasswordRequired");
                            }} */
                            color='primary'
                            disabled
                            checked={strongPasswordRequired}
                          />
                        }
                        label='Strong Password Required'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'drugGrossAmount');
                            }}
                            checked={drugGrossAmount}
                          />
                        }
                        label='Drug Gross Amount'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-md'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'showAlternateTheraClass');
                            }}
                            checked={showAlternateTheraClass}
                          />
                        }
                        label='Show Alternate Thera Class'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className='float-right  hide-on-print'
              style={{ marginBottom: '10px', marginTop: '0.75rem' }}
            >
              <Button
                className='btn-success same-font-family'
                disabled={isReadOnly || !isEnabledByRole}
                onClick={() => {
                  if (isEnabledByRole) {
                    setSuccessMessage([]);
                    setOpenConfirmationPopup(true);
                  }
                }}
              >
                <SVGComponent iconName='Create-new-icon' />
                {'  '} Enable Strong Password
              </Button>
            </div>
          </div>
        </fieldset>
        <fieldset className='custom-fieldset'>
          <legend className='same-font-family'>FTP Options</legend>
          <form autoComplete='off'>
            <div className='off'>
              <div className='row mb-2'>
                <div className='col-md'>
                  <div className='form-wrapper vertical-wrapper'>
                    <div className='mui-custom-form with-select input-md override-width-95'>
                      <TextField
                        id='ipaddress'
                        label='IP Address'
                        fullWidth
                        placeholder=''
                        onChange={(e) => {
                          handleChange(e, 'iPAddress');
                        }}
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          !fTPCMSUtilizationTape
                        }
                        value={iPAddress}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxlength: 15,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md'>
                  <div className='form-wrapper vertical-wrapper'>
                    <div className='mui-custom-form with-select input-md override-width-95'>
                      <TextField
                        id='userid'
                        label='User ID'
                        fullWidth
                        placeholder=''
                        onChange={(e) => {
                          handleChange(e, 'userID');
                        }}
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          !fTPCMSUtilizationTape
                        }
                        value={userID}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxlength: 32,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md'>
                  <div className='form-wrapper vertical-wrapper'>
                    <div className='mui-custom-form with-select input-md override-width-95'>
                      <TextField
                        id='password'
                        label='Password'
                        fullWidth
                        placeholder=''
                        onChange={(e) => {
                          handleChange(e, 'passwordtxt');
                        }}
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          !fTPCMSUtilizationTape
                        }
                        value={passwordtxt}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxlength: 32,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
        <fieldset className='custom-fieldset'>
          <legend className='same-font-family'>Database</legend>
          <form autoComplete='off'>
            <div className='off'>
              <div className='row mb-2'>
                <div className='col-md'>
                  <div className='form-wrapper vertical-wrapper'>
                    <div className='mui-custom-form with-select input-md override-width-95'>
                      <TextField
                        id='external_file_directory'
                        label='External File Directory'
                        fullWidth
                        placeholder=''
                        disabled
                        value={
                          payload && payload.length > 0
                            ? payload[0].extFileDir
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxlength: 120,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md'>
                  <div className='form-wrapper vertical-wrapper'>
                    <div className='mui-custom-form with-select input-md override-width-95'>
                      <TextField
                        id='current_environment'
                        label='Current Environment'
                        fullWidth
                        placeholder=''
                        disabled
                        value={
                          payload && payload.length > 0
                            ? payload[0].aboutMessageText
                            : null
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          maxlength: 100,
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col-md' />
              </div>
            </div>
          </form>
        </fieldset>
        <fieldset className='custom-fieldset pl-4'>
          <form autoComplete='off'>
            <div className='off'>
              <div className='row m-3'>
                <div className='form-wrapper vertical-wrapper'>
                  <div
                    className='mui-custom-form no-margin min-md'
                    style={{ width: '270px' }}
                  >
                    <div className='sub-radio text-black sub-label'>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color='primary'
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'messageText');
                            }}
                            checked={messageText}
                          />
                        }
                        label='Security Login Message'
                        labelPlacement='end'
                      />
                    </div>
                  </div>
                </div>
              </div>
              <label htmlFor='comments' style={{ display: 'none' }}>
                Hidden Label
              </label>
              <textarea
                id='comments'
                onChange={(e) => {
                  handleChange(e, 'textMessage');
                }}
                maxLength={150}
                value={textMessage}
                aria-label='Comments'
               disabled={!messageText || isReadOnly || !isEnabledByRole}
                minRows={3}
                style={{ width: '653px', height: '92px' }}
              />
              <div className='btn-wrapper float-right mr-4 mt-5'>
                <Button
                  className='btn btn-success btn-save btn-primary'
                  data-testid='view-history'
                  type='button'
                  onClick={() => {
                    handleViewHistory();
                  }}
                >
                  <SVGComponent iconName='Icon-view-history' /> View History
                </Button>
              </div>
            </div>
          </form>
        </fieldset>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='PARAM_GENERAL'
          keyValue={keyValue}
        />
      )}
    </>
  );
}
export default withRouter(GeneralSystemParameters);
